
const PaymentPolicy = () => {
  return (
    <>
      <div className="policy-wrapper bg-white overflow-hidden">
        <div className="w-screen h-64 md:h-[430px] border-[3px] border-[#35A93E]">
          <img
            src="/payment.jpeg"
            alt="Payment Banner"
            className="w-full h-full object-contain md:object-contain"
          />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 my-6">
          <div className="border-b border-gray-200 pb-6 mb-10">
            <h1 className="text-2xl font-bold text-gray-900">
              Fees & Payment Policy
            </h1>
          </div>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              1. Introduction
            </h2>
            <p className="text-base text-gray-700 leading-7">
              This Fees & Payment Policy outlines the applicable charges,
              payment methods, and billing terms for users of the LifeOnPlus
              platform, including e-commerce consumers, members, channel
              partners, virtual investors, and network marketing participants.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              2. Applicability
            </h2>
            <p className="text-base text-gray-700 leading-7">
              This policy applies to the following categories of users:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-7 mt-2">
              <li className="mb-2">
                E-commerce consumers purchasing health products and services.
              </li>
              <li className="mb-2">
                Channel partners authorized for distribution and reselling.
              </li>
              <li className="mb-2">
                Members enrolled under the network marketing program.
              </li>
              <li className="mb-2">
                Virtual partners/investors engaging in revenue-based models.
              </li>
              <li className="mb-2">
                Corporate or institutional partners subscribing to LifeOnPlus
                services.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              3. Fees for E-Commerce Users
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                Prices for products and services (e.g., health cards,
                diagnostics, body recharge therapies) are listed on the
                LifeOnPlus platform.
              </li>
              <li className="mb-2">
                All prices are inclusive of applicable taxes unless stated
                otherwise.
              </li>
              <li className="mb-2">
                Delivery charges, service fees, or consultation fees may apply
                based on the nature of the order.
              </li>
              <li className="mb-2">
                Promotional offers, discounts, or cashback campaigns will be
                subject to terms and validity periods.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              4. Fees for Channel Partners, Members & Virtual Investors
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                <strong>Channel Partners:</strong> Required to pay onboarding
                and license fees, as agreed under their distributor agreement.
              </li>
              <li className="mb-2">
                <strong>Network Marketing Members:</strong> May pay subscription
                or membership activation fees to participate in reward and
                income programs.
              </li>
              <li className="mb-2">
                <strong>Virtual Partners:</strong> Investment amounts and
                associated revenue share terms will be governed by the
                Subscription/Investment Agreement.
              </li>
              <li className="mb-2">
                Partners may also be charged technology fees, platform usage
                fees, or annual renewal charges.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              5. Payment Terms & Methods
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                Accepted modes: UPI, credit/debit cards, net banking, mobile
                wallets, and bank transfers.
              </li>
              <li className="mb-2">
                Payment must be completed at the time of order placement unless
                otherwise agreed in writing.
              </li>
              <li className="mb-2">
                For partners and members, payment confirmation is mandatory
                before accessing program benefits or sales tools.
              </li>
              <li className="mb-2">
                EMI options, if offered, are subject to approval by third-party
                financial service providers.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              6. Invoicing & Receipts
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                Tax invoices will be generated and sent via registered email
                upon successful payment.
              </li>
              <li className="mb-2">
                Users can also download invoices from the LifeOnPlus dashboard.
              </li>
              <li className="mb-2">
                Channel partners and institutional buyers may request
                consolidated monthly invoices.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              7. Late Payments & Non-Compliance
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                Delayed payments by partners or members may lead to suspension
                of access, penalties, or termination as per agreement.
              </li>
              <li className="mb-2">
                LifeOnPlus reserves the right to initiate legal proceedings for
                defaulted dues as per Indian contract law.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              8. Refunds & Disputes
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                Refunds will be processed as per the LifeOnPlus Refund & Returns
                Policy.
              </li>
              <li className="mb-2">
                Disputes regarding overcharging or billing errors must be raised
                within 7 business days of payment.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              9. Policy Updates
            </h2>
            <p className="text-base text-gray-700 leading-7">
              LifeOnPlus reserves the right to revise this policy at its
              discretion. Users are encouraged to periodically review updates.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              10. Contact
            </h2>
            <p className="text-base text-gray-700 leading-7">
              For billing queries, contact:
            </p>
            <p className="text-base text-gray-700 leading-7 mt-3">
              Email:{" "}
              <a
                href="mailto:support@lifeonplus.com"
                className="text-blue-600 hover:underline"
              >
                support@lifeonplus.com
              </a>{" "}
              or{" "}
              <a
                href="mailto:legal@lifeonplus.com"
                className="text-blue-600 hover:underline"
              >
                legal@lifeonplus.com
              </a>
              <br />
              Address: Lifeonplus Technologies India Private Limited, No.301,
              3rd Floor, “Master Mind 1, Royal Palms”, Aarey Milk Colony,
              Goregaon (East), Mumbai-400065
              <br />
              Contact: 📞{" "}
              <a
                href="tel:+919986880000"
                className="text-blue-600 hover:underline"
              >
                99868 80000
              </a>{" "}
              | ✉️{" "}
              <a
                href="mailto:info@lifeonplus.com"
                className="text-blue-600 hover:underline"
              >
                info@lifeonplus.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default PaymentPolicy;
